const INIT_STATE = { data: [], error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "GET_FAQ_SUCCESS":
      return {
        ...state,
        data: action.payload.data.categories,
        error: null,
      };
    case "GET_FAQ_ERROR":
      return { ...state, data: [], error: action.payload };
    default:
      return state;
  }
};
